<template>
  <div class="participant-info-row">
    <div class="row">
      <div class="col-md-3">
        <div class="field-value body-text">
          {{participant.firstName}} {{participant.lastName}}
        </div>
      </div>
      <div class="col-md-4">
        <div class="field-value body-text field-email-wrapper">
          <div class="field-email">
            {{participant.email}}
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="field-value body-text">
          {{participant.employeeId}}
        </div>
      </div>
      <div class="col-md-2">
        <div class="">
          <button class="ap-btn primary add-participant" @click="addParticipantBtn">ADD</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';

  import {mapGetters, mapActions, mapMutations} from 'vuex';

  // import constant from '../../_consts';

  export default {
    name: 'patientDetail',
    components: {
      Icon
    },
    props: {
      participant: {},
      slot: {},
      requestUpdateTable: {
        type: Function
      },
      fluShot: 0
    },
    data () {
      return {
      }
    },
    methods: {
      addParticipantBtn () {
        if (this.slot.eventParticipants === null) {
          this.slot.eventParticipants = [this.participant];
        } else {
          this.slot.eventParticipants[0] = this.participant;
        }
        let body = {
          slotId: this.slot.id,
          eventId: this.slot.eventId,
          hasBiometric: this.slot.hasBiometric === true,
          hasFluShot: this.slot.hasFluShot ? this.fluShot : 0,
          eventParticipant: {
            ...this.participant
          }
        };
        this.addParticipant(body).then(response => {
          this.updateSlot(response);
          if (response.statusCodes !== 'BAD_REQUEST' && !response.message) {
            this.requestUpdateTable();
          }
        });
      },
      updateSlot (res) {
        if (res.message !== null) {
          this.slot.eventParticipants = {};
          this.$toast.success(res.message, '', {
            ...this.$toastOpt.optError
          });
        } else {
          let slotDto = res.eventSlotDto;
          this.slot.eventParticipants = slotDto.eventParticipants;
          this.slot.status = slotDto.status;
          this.slot.numParticipant = slotDto.numParticipant;
          this.$toast.success('Successfully adding participant.', '', {
            ...this.$toastOpt.optSuccess
          });
          this.$modal.hide('modalSearchParticipant');
        }
      },
      ...mapActions({
        addParticipant: 'ACTION_ADD_PARTICIPANT'
      }),
      ...mapMutations({
        //  setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {
      ...mapGetters({
        getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
      })
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';
  .participant-info-row{
    padding: 0 16px;
    border-bottom: 1px solid #E6E6E6;
    background-color: white;

    .field-value {
      color: #1D1D1D;
      height: 72px;
      display: flex;
      align-items: center;
    }

    .field-email-wrapper{
      .field-email{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow:hidden;
        display:inline-block;
        width: 100%;
      }
    }
    .add-participant {
      width: 83px;
      height: 32px;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// ParticipantTableInfo.vue?16ce2b5f